import { useNavigate } from '@remix-run/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';
import Modal from '~/components/Modal';

import useIsLoggedIn from '~/hooks/useIsLoggedIn';

interface Props {
  isUpgradeActive: boolean;
}

const PremiumMemberModal = ({ isUpgradeActive }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isLoggedIn = useIsLoggedIn();
  const [modalOpen, setModalOpen] = useState(isUpgradeActive);

  return (
    <Modal
      title={t('stripe.upgrade_warning.modal.title')}
      message={t('stripe.upgrade_warning.modal.message')}
      isOpen={modalOpen}
      onClose={() => setModalOpen(false)}
      // biome-ignore lint/correctness/noChildrenProp: Keeping for backwards compatibility
      children={
        <div className="flex w-full justify-end">
          {!isLoggedIn && <Button onClick={() => navigate('/login')}>{t('shared.cta.login')}</Button>}
        </div>
      }
    />
  );
};

export default PremiumMemberModal;
